import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import ModalConfirmation from 'Common/Components/ModalConfirmation';
import { selectCredentialIdToDelete, selectCredentialsSelected, selectDeleteConfirmation, selectIsFetching } from 'store/Credentials/selectors';
import { deleteCredential, deleteCredentials, showCredentialModalDelete } from 'store/Credentials/actions';

const DeleteConfirmationModal = ({ isVulnDetail }) => {
  const dispatch = useDispatch();
  const isFetching = useSelector(selectIsFetching);
  const showDeleteConfirmation = useSelector(selectDeleteConfirmation);
  const credentialsSelected = useSelector(selectCredentialsSelected);
  const count = isVulnDetail ? 1 : credentialsSelected?.length;
  const idInVulnDetail = useSelector(selectCredentialIdToDelete);
  const credentialId = get(credentialsSelected, '[0].id', 0);
  const id = isVulnDetail ? idInVulnDetail : credentialId;

  const onClose = () => dispatch(showCredentialModalDelete(false));

  const onSubmit = () => {
    if (count === 1) dispatch(deleteCredential(id, isVulnDetail));
    else dispatch(deleteCredentials());
    onClose();
  };

  return (
    <ModalConfirmation
      show={ showDeleteConfirmation }
      handleSubmit={ onSubmit }
      handleClose={ onClose }
      entity="credential"
      count={ count }
      loading={ isFetching }
    />
  );
};

export default DeleteConfirmationModal;
